import { object } from '@calendly/form/validation'

import {
  formatBuffersValues,
  getFormatEventLimitsValues,
  getBuffersInitialValues,
  getEventLimitsInitialValues,
  getEventLimitsValidationSchema,
  prepareNoticePeriodValuesForPreview,
  prepareEventLimitsValuesForPreview,
  prepareSpotStepValuesForPreview,
  prepareLockTimezoneValuesForPreview,
  prepareBuffersValuesForPreview
} from 'components/event_type_edit'

export const getInitialValues = (eventType) => ({
  ...getBuffersInitialValues(eventType),
  ...getEventLimitsInitialValues(eventType),
})

export const getFormatValuesToServerData = (eventType) => (values) => {
  const formatEventLimitsValues = getFormatEventLimitsValues(eventType)

  return ({
    ...formatBuffersValues(values),
    ...formatEventLimitsValues(values)
  })
}

export const getValidationSchema = () => object({})
  .concat(getEventLimitsValidationSchema())

export const prepareValuesForPreview = (eventType, formValues) => ({
  ...prepareLockTimezoneValuesForPreview(eventType, formValues),
  ...prepareBuffersValuesForPreview(eventType, formValues),
  ...prepareNoticePeriodValuesForPreview(eventType, formValues),
  ...prepareEventLimitsValuesForPreview(eventType, formValues),
  ...prepareSpotStepValuesForPreview(eventType, formValues),
})
